module.exports = __webpack_public_path__ + "media/images/marketplace_by_exec-92b8b5ab.png";